export const JOURNEY_TRIGGER = {
  hidden: false,
  label: 'Event Trigger',
  value: 'journey-trigger',
  tabs: ['profile-viewer', 'branding', 'integrations'],
}
